define('Analytics',[],function(){
    return{
        trackView : function(){},
        sendEvent : function(){}
    }
});
